import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, MessageCircle } from "lucide-react";
import { FAQ } from "@/data/content";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/site/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Contact = () => {
  const SITE = useContent();
  const waNumber = SITE.phone.replace(/\D/g, "");
  const waText = encodeURIComponent("Olá Inês, tenho algumas dúvidas antes de marcar a minha consulta.");
  const waUrl = `https://wa.me/${waNumber}?text=${waText}`;
  return (
  <section id="contacto" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16">
      <div>
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-rose-800">Perguntas frequentes</span>
          <h2 className="font-display font-light text-4xl sm:text-5xl text-stone-900 mt-4 leading-[1.05]">
            Antes de começar
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-rose-100">
                <AccordionTrigger className="text-left font-display text-xl text-stone-900 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-stone-600 leading-relaxed text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>

      <div>
        <Reveal>
          <div className="rounded-[2rem] bg-[#FAF7F7] border border-rose-100 p-10">
            <h3 className="font-display text-3xl text-stone-900">Vamos conversar</h3>
            <p className="mt-3 text-stone-600 text-sm leading-relaxed max-w-sm">
              O primeiro passo é sempre o mais difícil. Estou aqui para o tornar mais leve.
            </p>

            <div className="mt-8 space-y-4">
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 group" data-testid="contact-email">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-white border border-rose-100 text-rose-700">
                  <Mail className="w-4 h-4" />
                </span>
                <span className="text-stone-700 group-hover:text-rose-800 transition-colors">{SITE.email}</span>
              </a>
              <a href={`tel:${SITE.phone}`} className="flex items-center gap-4 group" data-testid="contact-phone">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-white border border-rose-100 text-rose-700">
                  <Phone className="w-4 h-4" />
                </span>
                <span className="flex flex-col">
                  <span className="text-stone-700 group-hover:text-rose-800 transition-colors">{SITE.phone}</span>
                  <span className="text-xs text-stone-400">Chamada para a rede móvel nacional</span>
                </span>
              </a>
              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-4 group"
                data-testid="contact-instagram"
              >
                <span className="grid place-items-center w-11 h-11 rounded-full bg-white border border-rose-100 text-rose-700">
                  <Instagram className="w-4 h-4" />
                </span>
                <span className="text-stone-700 group-hover:text-rose-800 transition-colors">{SITE.instagram}</span>
              </a>
              <div className="flex items-center gap-4">
                <span className="grid place-items-center w-11 h-11 rounded-full bg-white border border-rose-100 text-rose-700">
                  <MapPin className="w-4 h-4" />
                </span>
                <span className="text-stone-700">{SITE.location}</span>
              </div>
            </div>

            <Link
              to="/marcacao"
              data-testid="contact-book-btn"
              className="btn-rose mt-9 inline-flex w-full items-center justify-center rounded-full bg-rose-800 text-white px-8 py-4 text-sm"
            >
              Agendar a minha consulta
            </Link>

            <a
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-whatsapp-btn"
              className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full border border-[#25D366]/40 bg-[#25D366]/10 text-[#128C4B] px-8 py-4 text-sm hover:bg-[#25D366]/20 transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              Dúvidas antes de começar? Fale connosco no WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
